/**
 * <s-loop-video> keeps a decorative, muted background video playing on an endless loop.
 * Native `loop` can be dropped by some browsers and preview frames, so this element
 * restarts playback on `ended`, retries after a pause or autoplay refusal, and resumes
 * when the tab becomes visible again.
 */
class SLoopVideo extends HTMLElement {
  #ac;

  connectedCallback() {
    const video = this.querySelector('video');
    if (!video) return;
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    video.muted = true;
    video.loop = true;
    video.playsInline = true;

    const play = () => {
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    };

    video.addEventListener('ended', () => {
      video.currentTime = 0;
      play();
    }, opts);
    video.addEventListener('pause', () => {
      if (!document.hidden) requestAnimationFrame(play);
    }, opts);
    video.addEventListener('canplay', play, opts);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) play();
    }, opts);

    play();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-loop-video')) customElements.define('s-loop-video', SLoopVideo);
